<template>
  <div class="input-group">
    <input class="form-control"
           :name="props.name"
           :id="props.id"
           v-model="barcodeValue"
           :type="numberOnly ? 'tel': 'text'"
           :inputmode="numberOnly ? 'numeric': 'text'"
           :disabled="isAutomatic"
           v-maska="maskaOptions"
    />
    <div class="input-group-append">
      <button type="button"
              :class="[
                numberOnly ? 'text-danger' : 'text-success',
                'btn tw:bg-zinc-100 tw:border tw:border-zinc-300',
              ]"
              @click.prevent="numberOnly = !numberOnly"
              :disabled="isAutomatic"
      >
        <i class="fa fa-font"></i>
      </button>
    </div>
  </div>
  <div class="form-check">
    <input type="checkbox"
           name="barcodeAuto"
           value="1"
           class="form-check-input"
           id="frm_barcodeAuto"
           v-model="isAutomatic"
           :disabled="isAutomaticDisabled"
    />
    <label class="form-check-label" for="frm_barcodeAuto">
      {{ $t('Generate an automatic barcode') }}
    </label>
  </div>
</template>

<script setup lang="ts">
import { ref, defineProps, watch, onMounted, computed } from "vue";
import { vMaska } from "maska/vue"
import type { MaskInputOptions } from "maska"
const props = defineProps({
  id: {
    type: String,
    default: ""
  },
  name: {
    type: String,
    default: ""
  },
  modelValue: {
    type: String,
    default: ""
  },
})

const barcodeValue = ref(props.modelValue);
const isAutomatic = ref(false);
const numberOnly = ref(true)
const isAutomaticDisabled = ref(!!props.modelValue);

const maskaOptions = computed<MaskInputOptions>( () => {
  return {
    mask: numberOnly.value ? '9' : 'A',
    tokens: {
      '9': {
        pattern: /[0-9]/,
        repeated: true,
      },
      'A': {
        pattern: /[a-zA-Z0-9./:\-_#()]/,
        repeated: true,
      },
    },
  }
})

const emit = defineEmits(['update:modelValue']);
watch(
  barcodeValue,
  (newValue) => {
    if (newValue !== props.modelValue) {
      emit('update:modelValue', newValue);
    }
    if (newValue === '') {
      isAutomaticDisabled.value = false;
    }
  }
)

watch(
  () => props.modelValue,
  (newValue) => {
    barcodeValue.value = newValue;
  }
)

onMounted(() => {
  if (props.modelValue !== '' && ! /^\d+$/.test(props.modelValue)) {
    numberOnly.value = false;
  }
})

</script>
